import { MessageCircle, Clock, CheckCircle2 } from "lucide-react";

const WA_LINK =
  "https://wa.me/5491165162564?text=Hola%2C%20quiero%20hacer%20una%20consulta%20contable.";

export const Contact = () => {
  return (
    <section
      id="contacto"
      data-testid="contact-section"
      aria-label="Contacto con Bárbara Cargnello"
      className="bg-cream-300 py-16 md:py-24"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-stretch gap-10 md:gap-16 lg:grid-cols-2">
          <div className="flex flex-col justify-center">
            <span className="mb-3 inline-block font-poppins text-sm font-medium uppercase tracking-wide text-gold">
              Contacto
            </span>

            <h2 className="mb-6 font-poppins text-3xl font-semibold text-navy-900 md:text-4xl">
              Envianos tu consulta
            </h2>

            <p className="mb-8 font-inter text-base leading-relaxed text-navy-700 md:text-lg">
              Si tenés dudas, necesitás un presupuesto o querés solicitar
              atención personalizada, escribime por WhatsApp y contame tu caso.
            </p>

            <address className="not-italic space-y-5">
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-link"
                aria-label="Consultar por WhatsApp"
                className="group flex items-center gap-4"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-whatsapp/10 transition-colors group-hover:bg-whatsapp/20">
                  <MessageCircle className="h-5 w-5 text-whatsapp" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-poppins text-sm font-medium text-navy-900">WhatsApp</p>
                  <p className="font-inter text-sm text-navy-600">+54 9 11 6516-2564</p>
                </div>
              </a>

              <div className="flex items-center gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10">
                  <Clock className="h-5 w-5 text-gold" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-poppins text-sm font-medium text-navy-900">
                    Horario de respuesta
                  </p>
                  <p className="font-inter text-sm text-navy-600">
                    Lunes a viernes - respuesta en el día
                  </p>
                </div>
              </div>
            </address>
          </div>

          <div className="flex flex-col justify-center rounded-2xl border border-navy-900/5 bg-white p-6 shadow-sm md:p-10">
            <div className="relative overflow-hidden rounded-2xl border border-navy-900/5 bg-gradient-to-br from-whatsapp/10 via-white to-gold/10 p-6 md:p-8">
              <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-whatsapp/10 blur-3xl" />
              <div className="absolute -bottom-10 -left-10 h-36 w-36 rounded-full bg-gold/10 blur-3xl" />

              <div className="relative z-10">
                <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-whatsapp shadow-lg">
                  <MessageCircle className="h-7 w-7 text-white" strokeWidth={1.8} />
                </div>

                <h3 className="mb-3 font-poppins text-2xl font-semibold text-navy-900 md:text-3xl">
                  Pedí presupuesto por WhatsApp
                </h3>

                <p className="mb-6 font-inter leading-relaxed text-navy-700">
                  Es la forma más rápida de iniciar la consulta, compartir tu
                  situación y recibir una cotización personalizada.
                </p>

                <a
                  href={WA_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-whatsapp px-8 py-3.5 font-poppins text-base font-medium text-white shadow-md transition-all duration-200 hover:scale-[1.02] hover:opacity-95"
                  aria-label="Abrir WhatsApp para hacer una consulta"
                >
                  <MessageCircle className="h-5 w-5" />
                  Solicitar atención personalizada
                </a>

                <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
                  <div className="rounded-xl border border-navy-900/5 bg-white/80 p-4">
                    <CheckCircle2 className="mb-2 h-5 w-5 text-whatsapp" />
                    <p className="font-poppins text-sm font-medium text-navy-900">
                      Respuesta rápida
                    </p>
                  </div>

                  <div className="rounded-xl border border-navy-900/5 bg-white/80 p-4">
                    <CheckCircle2 className="mb-2 h-5 w-5 text-whatsapp" />
                    <p className="font-poppins text-sm font-medium text-navy-900">
                      Atención personalizada
                    </p>
                  </div>

                  <div className="rounded-xl border border-navy-900/5 bg-white/80 p-4">
                    <CheckCircle2 className="mb-2 h-5 w-5 text-whatsapp" />
                    <p className="font-poppins text-sm font-medium text-navy-900">
                      Online
                    </p>
                  </div>
                </div>

                <p className="mt-6 text-center font-inter text-sm text-navy-600">
                  También podés escribir a{" "}
                  <a
                    href={WA_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-gold hover:underline"
                  >
                    este link directo
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

